import { ErrorMessage, Field, Form, Formik } from 'formik'
import React from 'react'
import { useState } from 'react'
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { Button } from '../../components';
import { validationEnterpriseRegister } from '../../validations/validationEnterpriseRegister';
import { useDispatch } from 'react-redux';
import { addNewEnterpriseAndAdmin } from '../../redux/AdminInmersys/thunks';

export const ModalAddEnterprise = ({ closeModal }) => {
    const dispatch = useDispatch()
    const [page, setPage] = useState(1)
    const [file, setFile] = useState(null)

    const onSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            console.log(file)
            const response = await dispatch(addNewEnterpriseAndAdmin(values))
            if (response) {
                resetForm({});
                closeModal()
            }
            // navigate(PrivatePath.vrTraining);
        } catch (error) {
            setSubmitting(false);
        }
    };

    const props = {
        name: "file",
        multiple: false,
        accept: ".png",
        beforeUpload: (file) => {
            setFile(file)
            console.log(file)
        },
        onDrop(e) {
            console.log("Dropped files", e.dataTransfer.files);
        },
    };

    return (
        <div className="w-full h-full pt-2 px-4">
            <Formik
                initialValues={{
                    name: "",
                    nameProyect: "",
                    typeUser: '',
                    userName: "",
                    lastName: "",
                    email: "",
                    password: '',
                    passwordConfirm: ''
                }}
                validationSchema={validationEnterpriseRegister}
                onSubmit={onSubmit}
            >
                {({ handleSubmit, handleChange, values }) => (
                    <Form>
                        {
                            page === 1
                                ?
                                <div className='h-[495px]'>
                                    <div className="py-1">
                                        <p className="text-[#686868] text-base font-medium">Nombre de empresa</p>
                                        <Field
                                            className="w-full text-[#686868] pb-3 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="text"
                                            placeholder="ingresa el nombre de la nueva empresa"
                                            name="name"
                                            onChange={handleChange}
                                            value={values.name}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="name" />
                                    </div>
                                    <div className="pt-1">
                                        <p className="text-[#686868] text-base font-medium">Nombre del primer proyecto </p>
                                        <Field
                                            className="w-full text-[#686868] pb-3 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="text"
                                            placeholder="ingresa el nombre del primer proyecto "
                                            name="nameProyect"
                                            onChange={handleChange}
                                            value={values.nameProyect}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="nameProyect" />
                                    </div>
                                    <div className='py-4' >
                                        <p className="text-[#686868] text-base font-medium pb-2">Imagen de logo</p>
                                        <Dragger {...props} height={200}>
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined className="text-3366FF" />
                                            </p>
                                            <p className="ant-upload-text">Selecciona o suelta un archivo en esta área para cargarlo.</p>
                                            <p className="ant-upload-hint">La imágen será mostrada en formato 16:9. Solo archivos .png  no mayores a 500 KB. Solo logos en su versión blanco.</p>
                                        </Dragger>
                                    </div>
                                    <div className='py-4' >
                                        <p className="text-[#686868] text-base font-medium pb-2">¿A qué producto pertenece?</p>
                                        <div className='flex pb-2'>
                                            <Field type="radio" name='typeUser' value="VRT" ></Field>
                                            <p className='ml-3 text-sm text-[#686868] '>Inmersys VR Training</p>
                                        </div>
                                        <div className='flex'>
                                            <Field type="radio" name='typeUser' value="VRL"></Field>
                                            <p className='ml-3 text-sm text-[#686868] '>Inmersys VR Learning</p>
                                        </div>
                                        <ErrorMessage component="a" className="text-red-600 " name="typeUser" />
                                    </div>
                                </div>
                                :
                                <div className='h-[495px] '>
                                    <div className="pb-4">
                                        <p className="text-[#686868] pb-2 text-base font-medium">Nombre</p>
                                        <Field
                                            className="w-full text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="text"
                                            placeholder="Ingresa el nombre del usuario "
                                            name="userName"
                                            onChange={handleChange}
                                            value={values.userName}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="userName" />
                                    </div>
                                    <div className="py-3">
                                        <p className="text-[#686868] pb-2 text-base font-medium">Apellidos</p>
                                        <Field
                                            className="w-full text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="text"
                                            placeholder="Ingresa los apellidos del usuario"
                                            name="lastName"
                                            onChange={handleChange}
                                            value={values.lastName}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="lastName" />
                                    </div>
                                    <div className="py-3">
                                        <p className="text-[#686868] pb-2 text-base font-medium">Correo electrónico</p>
                                        <Field
                                            className="w-full text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="text"
                                            placeholder="ingresa el correo electrónico"
                                            name="email"
                                            onChange={handleChange}
                                            value={values.email}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="email" />
                                    </div>
                                    <div className="py-3">
                                        <p className="text-[#686868] pb-2 text-base font-medium">Contraseña</p>
                                        <Field
                                            className="w-full text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="password"
                                            placeholder="Crea la contraseña de la nueva empresa"
                                            name="password"
                                            onChange={handleChange}
                                            value={values.password}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="password" />
                                    </div>
                                    <div className="py-3">
                                        <p className="text-[#686868] pb-2 text-base font-medium">Confirmación de contraseña</p>
                                        <Field
                                            className="w-full text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black placeholder:text-[#cdcdcd]"
                                            type="password"
                                            placeholder="Confirma la contraseña de la nueva empresa"
                                            name="passwordConfirm"
                                            onChange={handleChange}
                                            value={values.passwordConfirm}
                                            autoComplete="none"
                                        />
                                        <ErrorMessage component="a" className="text-red-600 " name="passwordConfirm" />
                                    </div>
                                </div>
                        }
                        <div className="absolute z-50 w-full pr-8">
                            <div className="w-full h-6 pb-4 flex justify-center items-center">
                                <div className={`mx-2 rounded-full w-2 h-2 bg-[#3366ff] ${page === 1 ? '' : 'bg-opacity-20'}`}></div>
                                <div className={`mx-2 rounded-full w-2 h-2 bg-[#3366ff] ${page === 2 ? '' : 'bg-opacity-20'}`}></div>
                            </div>
                            <div className="w-full flex justify-end items-center">
                                <Button
                                    text="Atrás"
                                    isPrincipal={false}
                                    disabled={page === 1}
                                    onClick={() => {
                                        setPage(1)
                                    }}
                                />
                                <div className="w-4"></div>
                                <Button
                                    text={page === 2 ? 'Agregar' : 'Siguiente'}
                                    isPrincipal={true}
                                    onClick={(e) => {
                                        if (page === 1) {
                                            setPage(2)
                                        }
                                        else {
                                            handleSubmit()
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )

}

export default ModalAddEnterprise
